export default {
    'searchList': {
        'searchTxt': [{
            'name': '任务编号',
            'value': 'feeTaskCode',
            'type': 'input',
            'unfold': true,
            'span': 3
        },
        {
            'name': '服务平台',
            'value': 'siteName',
            'unfold': true,
            'advanceConfig': [
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
            ],
            'tableConfig': [
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' },
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' }
            ],
            'advanceUrl': '/searchPlatform',
            'type': 'advance',
            'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
            'span': 3
        },
        {
            'name': '分公司',
            'value': 'companyName',
            'unfold': true,
            'advanceConfig': [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            'tableConfig': [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            'advanceUrl': '/esCompany/popCompany',
            'type': 'advance',
            'cbParams': ['companyCode#companyCode', 'companyNameCn#companyName'],
            'span': 3
        },
        {
            'name': '任务类型',
            'value': 'feeTaskType',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'optionNum': 'SRM_BMS_TASK_TYPE',
            'multiple': false
        },
        {
            'name': '业务类型',
            'value': 'businessType',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'optionNum': 'BID_BUSINESS_TYPE',
            'multiple': false
        },
        {
            'name': '状态',
            'value': 'status',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'data': '30',
            'optionNum': 'SYS_BMS_TASK_STATUS',
            'options': [],
            'multiple': false
        }
        ],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table':
    {
        'selectBtn': true,
        'height': 400,
        'columns': [
            {
                'label': '任务编号',
                'prop': 'feeTaskCode',
                'width': '70px'
            },
            {
                'label': '网点名称',
                'prop': 'stationName',
                'width': '70px'
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                'width': '50px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'width': '50px'
            },
            {
                'label': '会计主体',
                'prop': 'ledgerName',
                'width': '110px'
            },
            {
                'label': '任务类型',
                'prop': 'feeTaskType',
                'width': '50px',
                'type': 'select',
                'optionNum': 'SRM_BMS_TASK_TYPE',
                'options': []
            },
            {
                'label': '业务类型',
                'prop': 'businessType',
                'width': '40px',
                'type': 'select',
                'optionNum': 'BID_BUSINESS_TYPE',
                'options': []
            },
            {
                'label': '含税总金额',
                'prop': 'amount',
                'width': '88px'
            },
            {
                'label': '状态',
                'prop': 'status',
                'width': '70px',
                'type': 'select',
                'optionNum': 'SYS_BMS_TASK_STATUS',
                'options': []
            }],
        'leftOperation': false
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
        // 'pageSizes': [10, 20, 30, 50, 100]
    }
};
